import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import indexMixin from "../mixins/index";
export default {
  name: "res-checkbox",
  mixins: [indexMixin],

  data() {
    return {
      dataModel: this.value,
      isIndeterminate: false,
      checkAll: false // layout：horizontal、vertical(只对非button模式起作用)

    };
  },

  props: {
    isButton: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    valueKey: {
      type: String,
      default: "value"
    },
    labelKey: {
      type: String,
      default: "label"
    },
    border: {
      type: Boolean,
      default: false
    },
    layout: {
      type: String,
      default: ""
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    dataModel: {
      handler(val) {
        this.isIndeterminate = val.length > 0 && val.length < this.options.length;
        this.$emit("input", val);
      },

      immediate: true,
      deep: true
    },

    value(val) {
      this.dataModel = val;
    }

  },
  computed: {
    indeterminateDisable() {
      // 有一个选项为disabled,则不能操作全选按钮
      return !!this.options.filter(item => {
        return item.disabled;
      }).length;
    },

    valueToLabel() {
      let values = this.dataModel ? this.dataModel : [];
      let label = [];
      this.options.forEach(item => {
        if (values.indexOf(item[this.valueKey]) !== -1) {
          label.push(item[this.labelKey]);
        }
      });
      label = label.join("、"); // 没有label默认取value值

      return label || values.join("、");
    },

    allValue() {
      // 所有选项的value值
      return this.options.length ? this.options.reduce((pre, next) => {
        return [...pre, next[this.valueKey]];
      }, []) : [];
    }

  },
  methods: {
    checkboxChange(val) {
      let checkedCount = val.length;
      this.checkAll = checkedCount === this.options.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.options.length; // console.log("change");

      this.$emit("change", val);
    },

    handleCheckAllChange(val) {
      this.dataModel = val ? this.allValue : [];
      this.isIndeterminate = false;
      this.$emit("change", this.dataModel);
      this.$emit("all-change", val);
    }

  },

  mounted() {}

};